(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headernew"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ia-cart-main"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", async () => {
    console.log("dom loading...")
    window.jmb = {
        init: false,
        featureFlag: false,
        stubs: {},
        cartData: {},
        customerId: {},
        draftOrderId: "",
        async getComputedPrice(cartData, customerTags, action) {
            document.querySelector("#checkoutBtn").setAttribute("disabled", "")

            let handles = []
            , discount = []
            , items = {}
            , skus = [];

            for (let o of cartData.items) {
                if (skus.includes(o.sku)) {
                    continue
                }

                handles.push(o.handle)
                skus.push(o.sku)

                Object.assign(items, {
                    [`${o.sku}`]: {
                        product_id: `gid://shopify/Product/${o["product_id"]}`,
                        variant_id: o.variant_id,
                        original_line_price: o.original_line_price,
                        quantity: o.quantity,
                    }
                })
            }

            if (cartData.cart_level_discount_applications.length !== 0) {
                discount.push(cartData.cart_level_discount_applications[0])
            }

            let cartCompute = { success: false }
            let response;
            
            try {
                response = await fetch("/apps/api/cart-compute", {
                    method: "POST",
                    body: JSON.stringify({
                        token: cartData.token ?? "",
                        draftOrderId: this.draftOrderId,
                        customerId: this.customerId,
                        note: cartData.note,
                        customAttributes: cartData.customAttributes,
                        customerTags,
                        discount,
                        handles,
                        action,
                        items,
                        skus 
                    })
                });
            }
            catch (err) {
                console.error(err)
                alert("There seems like an issue with the page. Kindly refresh the page or restart your browser. If it persist, please contact support.")
                return
            }

            if (response.ok) {
                cartCompute = await response.json()
                document.querySelector("#checkoutBtn").removeAttribute("disabled")
            }
            
            return cartCompute
        },
        async processDiscountCode(discountCode = "") {
            return await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    discount: discountCode
                })
            })
        },
        async saveCartData(customerId, cartItems, cartNote) {
            return await fetch("/apps/api/cart-catch", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    customerId,
                    cartItems,
                    cartNote,
                })
            })
        }
    }

    if (!window.jmb.init && document.querySelector("[data-cart-json]") !== null) {
        console.log("cart initializing...")
        window.jmb.init = true

        const customerId = document.querySelector("[data-customer-id]")
        window.jmb.customerId = customerId.value

        const itemPriceContainers = document.querySelectorAll(".item-price-container")
        const totalPriceEl = document.querySelector(".ia-total-price")
        const cartJson = document.querySelector("[data-cart-json]").textContent
        const cartData = JSON.parse(cartJson)
        window.jmb.cartData = cartData
        
        if (cartData.items.length > 0) {
            await window.jmb.saveCartData(customerId.value, cartData.items, cartData.note)
        }

        const customerTagsJson = document.querySelector("[data-customer-tags-json]").textContent
        const customerTags = JSON.parse(customerTagsJson)

        let responseData = await window.jmb.getComputedPrice(cartData, customerTags, "CART_LOAD")

        if (responseData.success === false) {
            alert("There seems like an issue with the page. Kindly refresh the page or restart your browser. If it persist, please contact support.")
            window.location.href = "https://immediateapparel.com/"
        }

        window.jmb.stubs = responseData.requestPaystub
        window.jmb.draftOrderId = responseData.requestPaystub.draftId

        for (let p of itemPriceContainers) {
            if (p.dataset.variantId !== "" && window.jmb.stubs[p.dataset.variantId]?.inventoryQuantity > 0) {
                p.textContent = window.jmb.stubs[p.dataset.variantId].finalPrice
            }
        }
        
        totalPriceEl.textContent = `$${Math.floor(responseData.requestPaystub.totalPrice * 100) / 100}`
    }

    if (!customElements.get('ia-cart-quantity-input')) {
        customElements.define('ia-cart-quantity-input', class IaCartQuantityInput extends HTMLElement {
            constructor() {
                super()
                this.iaCartUpdateEvent = new Event('ia-cart-update', { bubbles: true, cancelable: true })

                const id = this.getAttribute('id');
                const variantId = this.getAttribute('variant');
                const finalPrice = this.getAttribute('final-price');

                const inputPrice = this.querySelector(`[data-variant-${variantId}]`)
                const inputNumber = this.querySelector(`#ia-qty-input-${id}`);
                const inputMin = inputNumber.getAttribute('min')
                const inputMax = inputNumber.getAttribute('max')

                this.querySelector(`#ia-qty-plus-${id}`)
                    .addEventListener('click', (event) => {
                        event.preventDefault()
                        this.setLoading(id)

                        let inputValue = Number(inputNumber.value)
                        let priceUpdate = 0

                        if (inputValue < Number(inputMax)) {
                            inputNumber.stepUp()

                            if (!window.jmb.featureFlag) {
                                priceUpdate = Number(window.jmb.stubs[variantId].nPrice) * Number(inputNumber.value)
                                inputPrice.textContent = priceUpdate.toFixed(2)
                            }
                            
                            this.dispatchEvent(this.iaCartUpdateEvent);
                        }

                        this.removeLoading(id)
                    });

                this.querySelector(`#ia-qty-minus-${id}`)
                    .addEventListener('click', (event) => {
                        event.preventDefault()
                        this.setLoading(id)

                        let inputValue = Number(inputNumber.value)
                        let priceUpdate = 0
                        
                        if (inputValue > 1 || inputValue > Number(inputMin)) {
                            inputNumber.stepDown()
                            
                            if (!window.jmb.featureFlag) {
                                priceUpdate = Number(window.jmb.stubs[variantId].nPrice) * Number(inputNumber.value)
                                inputPrice.textContent = priceUpdate.toFixed(2)
                            }
                            
                            this.dispatchEvent(this.iaCartUpdateEvent);
                        }

                        this.removeLoading(id)
                    });

                inputNumber.addEventListener('change', (event) => {
                    let priceUpdate = 0
                    let inputValue = Number(inputNumber.value)

                    if (inputValue === 0) { return; }
                    if (inputValue < Number(inputMin)) { return; }
                    if (inputValue > Number(inputMax)) { return; }

                    this.setLoading(id)
                    priceUpdate = Number(window.jmb.stubs[variantId].nPrice) * Number(inputNumber.value)
                    inputPrice.textContent = priceUpdate.toFixed(2)
                    this.dispatchEvent(this.iaCartUpdateEvent)
                    this.removeLoading(id)
                });
            }

            setLoading(id) {
                this.querySelector(`#ia-qty-plus-${id}`).setAttribute("disabled", "")
                this.querySelector(`#ia-qty-minus-${id}`).setAttribute("disabled", "")
            }

            removeLoading(id) {
                setTimeout(() => {
                    this.querySelector(`#ia-qty-plus-${id}`).removeAttribute("disabled")
                    this.querySelector(`#ia-qty-minus-${id}`).removeAttribute("disabled")
                }, 250)
            }
        });
    }

    if (!customElements.get('ia-cart')) {
        customElements.define('ia-cart', class IaCart extends HTMLElement {
            constructor() {
                super()
                this.addEventListener('ia-cart-update', this.iaCartUpdate)
            }

            async iaCartUpdate(event) {
                event.preventDefault()
                document.querySelector(".ia-loading-spinner").classList.remove("hidden")

                const inputPrice = this.querySelector(`[data-variant-${event.target.getAttribute("variant")}]`)
                const inputNumber = this.querySelector(`#ia-qty-input-${event.target.getAttribute("id")}`)

                const cartChangeResponse = await fetch("/cart/change.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: event.target.getAttribute("key"),
                        quantity: Number(inputNumber.value),
                    })
                })

                if (!cartChangeResponse.ok) {
                    console.error("cart change failed")
                }

                if (cartChangeResponse.ok) {
                    const finalPriceEl = this.querySelector(".ia-total-price")
                    const item = window.jmb.stubs[event.target.getAttribute("variant")]

                    item.finalPrice = inputPrice.textContent
                    item.quantity = inputNumber.value

                    let computePrice = 0
                    
                    for (let o in window.jmb.stubs) {
                        if (o !== "totalPrice") {
                            computePrice = computePrice + Number(window.jmb.stubs[o].finalPrice)
                        }
                    }

                    if (window.jmb.cartData.cart_level_discount_applications.length) {
                        let dc = window.jmb.cartData.cart_level_discount_applications[0]
                        
                        if (dc.type === "discount_code" && dc.value_type === "fixed_amount") {
                            computePrice = computePrice - parseFloat(dc.value)
                        }
                        else {
                            computePrice = computePrice - (computePrice * (parseFloat(dc.value) / 100))
                        }
                    }

                    if (computePrice < 0) {
                        computePrice = 0
                    }

                    window.jmb.stubs.totalPrice = computePrice.toFixed(2)
                    finalPriceEl.textContent = `$${computePrice.toFixed(2)}`
                }

                document.querySelector(".ia-loading-spinner").classList.add("hidden")
            }
        })
    }

    if (document.getElementById("redeemDiscountBtn") !== null) {
        document.getElementById("redeemDiscountBtn")
            .addEventListener("click", async (ev) => {
                ev.preventDefault()
                const discountEl = document.querySelector("#discount")
                const discountPromo = discountEl.value.trim()

                let response = await window.jmb.processDiscountCode(discountPromo)
                let jsn = await response.json()

                if (jsn.discount_codes[0].applicable === true) {
                    window.location.reload()
                }

                if (jsn.discount_codes[0].applicable === false) {
                    window.jmb.processDiscountCode()
                        .then(() => {
                            document.querySelector(".ia-discount-not-applicable").classList.remove("hidden")
                        })
                        .catch((err) => console.error(err))
                }
            })
    }

    if (document.getElementById("discountRemoveBtn") !== null) {
        document.getElementById("discountRemoveBtn")
            .addEventListener("click", (ev) => {
                ev.preventDefault()
                window.jmb.processDiscountCode()
                    .then(() => { window.location.reload() })
                    .catch((err) => console.error(err))
            })
    }

    if (document.getElementById("jmbCart") !== null) {
        document.getElementById("jmbCart")
            .addEventListener("submit", async (ev) => {
                ev.preventDefault()
                // document.querySelector("#checkoutBtn").setAttribute("disabled", "")
                document.querySelector(".ia-loading-spinner").classList.remove("hidden")

                const cartNoteEl = document.querySelector("#cart-note")
                if (cartNoteEl.value !== "") {
                    await fetch(`${routes.cart_update_url}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            note: cartNoteEl.value.trim()
                        })
                    })
                }

                let cartGetResponse = await fetch("/cart.js", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })

                if (!cartGetResponse.ok) { return }

                let cartData = await cartGetResponse.json()

                if (document.getElementById("dropship") !== null) {
                    let customAttributes = []
                    customAttributes.push({
                        key: "Process As",
                        value: "Dropship"
                    })
                    Object.assign(cartData, { customAttributes })
                }

                let responseData = await window.jmb.getComputedPrice(cartData, "", "CART_SUBMIT")

                if (!responseData.success) {
                    alert("There seems like an issue with the page. Kindly refresh the page or restart your browser. If it persist, please contact support.")
                    return
                }

                window.jmb.stubs = responseData.requestPaystub
                window.jmb.draftOrderId = responseData.requestPaystub.draftId
                window.location.href = responseData.requestPaystub.invoiceUrl

                // window.location.reload()
                // document.querySelector("#checkoutBtn").removeAttribute("disabled")
                document.querySelector(".ia-loading-spinner").classList.add("hidden")
            })
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ia-home-scripts"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", async () => {
    if (document.querySelector("[data-customer-id]") !== null) {
        // const customer_id = document.querySelector("[data-customer-id]").textContent
        // console.log(customer_id.trim())

        // let cart_content_request = await fetch("/cart.js", {
        //     method: "GET"
        // })
        // let cart_content_json = await cart_content_request.json()
        // console.log(cart_content_json.items)

        // http://localhost:61262/
        // let catch_content_request = await fetch("http://localhost:61262/api/cart-catch/54321", {
        //     method: "GET",
        //     headers: {
        //         "Content-Type": "application/json"
        //     }
        // })
        // let catch_content_json = await catch_content_request.json()
        // console.log(catch_content_request)

        // if length > 0
        // send item to server
        // check if there are other content
            // consolidate the item and get the latest
        // update the cart
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", async () => {
    // const variantJson = document.querySelector("[data-variant-json]").textContent
})

  } catch(e) { console.error(e); }
})();
})();
